import DoctorModel from './Doctor.model';

export default class Doctors {
  constructor(apiResponse = []) {
    this.doctors = apiResponse
      .map((item) => new DoctorModel(item));
  }

  getDoctors() {
    return this.doctors;
  }
}
